import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { updateProject } from 'cd-eft/business/Projects/updateProject';
import * as mapPreferences from 'cd-eft/utils/mapPreferences';
import DelineateWatershedGpApi from 'cd-eft/services/DelineateWatershedGpApi/DelineateWatershedGpApi';
import { DelineateWatershedInputStateVM } from '../DelineateWatershedInput/DelineateWatershedInputStateVM';
import GraphicsLayerView from '@arcgis/core/views/layers/GraphicsLayerView';
import { esriProjection, FeatureLayer, Graphic, LayerList, MapView } from 'cd-eft/utils/esriTypes';
import ListItem from '@arcgis/core/widgets/LayerList/ListItem';
import { saveNote, updateNote } from 'cd-eft/business/Projects/saveNote';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import * as EFH2API from 'cd-eft/services/eftEfh2Api';
import { HydroWatershedController, DesignElementController, StructureDrawingsController } from 'cd-eft/services/eftSetApi';
import { SessionResourceObject } from 'cd-eft/models/Projects/sessionResources';
import { getRainfallCellID } from 'cd-eft/services/EFH2/getRainfallCellID';
import Polygon from '@arcgis/core/geometry/Polygon';
import Point from '@arcgis/core/geometry/Point';
import { ProjectCommentRequest } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { blockMostSpecialChars } from 'cd-eft/utils/blockMostSpecialChars';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { getSpatialRefByProject } from 'cd-eft/components/Projects/ProjectsLibrary/ProjectsLibraryVM';
import { ToolSlot } from 'cd-eft/components/Design/BreaklineTools/framework/Tool';
import {
  PendingEditManagerVM,
  IPendingEditManagerVMConstructorProps,
} from 'cd-eft/components/common/PendingEditManager/PendingEditManagerVM';
import { appConfig } from 'cd-eft/config/AppConfig';
import { Screenshot } from '../../common/Screenshot/Screenshot';
import { ScreenshotPreviewVM } from 'cd-eft/components/common/Screenshot/ScreenshotPreviewVM';
import { INotification } from 'cd-eft/models/Stores/DesignStore';
import { UserInfoController } from 'cd-eft/services/eftPrjAdminApi';

const AppStore = stores.AppStore;
const efh2Store = stores.AppStore.efh2Store;
const projectsLibraryStore = stores.AppStore.projectsLibraryStore;
const designStore = AppStore.designStore;
interface INoteOption {
  name: string;
  value: string;
}
export class GISBoxVM extends PendingEditManagerVM {
  @observable props;
  @observable activityViewModel: DelineateWatershedInputStateVM | undefined = undefined;
  history;
  @observable drawingDesignElementTypeId: number = 0;
  @observable drawingDesignElementName: string = "";
  disableAddButton: any;
  private gisErrorMessages: string[] = ['Hydro_67'];

  constructor(props: IPendingEditManagerVMConstructorProps, history: any) {
    super(props);
    this.props = props;
    this.history = history;
    this.watershedApi = new DelineateWatershedGpApi();
    this.toolSlot = new ToolSlot();

    this.drawingDesignElementTypeId = designStore.drawingTypeByDesignElementTypeId[appConfig.hardCodes.designElementTypeSuface].Id;
    this.drawingDesignElementName = designStore.drawingTypeByDesignElementTypeId[appConfig.hardCodes.designElementTypeSuface].name;
  }

  watershedApi: DelineateWatershedGpApi;

  @observable map: any = null;
  @observable view: any = '';
  @observable isLoading: boolean = true;
  @observable loadingResults: boolean = false;
  @observable hasDEM = true;
  @observable gisLoadingMessage = 'Loading...';
  @observable notification: INotification = { message: '', header: '', type: '', hidden: true, timestamp: undefined };
  @observable drawingNotification: any;
  @observable footerMessage: string = '';
  @observable mapDrawMethods: any = {};
  @observable showSaveProjModal: any = false;
  @observable showNotesModal: boolean = false;
  @observable showErrorModal: boolean = false;
  @observable errorModalMessage: string = '';
  @observable newProjectTitle: string = '';
  @observable disableSaveComment: boolean = true;
  @observable projectCommentInput: any;
  @observable projectSelectedInput: any;
  @observable showHelpModal: boolean = false;
  @observable helpModalContent: string = '';
  @observable helpModalTitle: string = '';
  @observable isDownloading: boolean = false;
  @observable loadingProgress: number = 0;
  @observable processName: string = '';

  private loaderStack: string[] = [];

  readonly toolSlot: ToolSlot;
  @observable userDestination = '';
  get checkInterruptCase(): boolean {
    if (window.location.pathname.includes('single-watershed')) {
      // On the right page
      if (this.activityViewModel?.hasRedo && !(this.activityViewModel?.canRedoLandUse && this.activityViewModel?.canRedo)) {
        // Redo Case
        return true;
      }
      else if (this.activityViewModel?.changesMade) {
        // New step case
        return true;
      }
    }
    return false;
  }
  unloadEventListener(event) {
    if (this.checkInterruptCase) {
      event.preventDefault();
      return (event.returnValue = 'Changes you made may not be saved.')
    }
  }
  @action.bound interruptInAppNavigation(window) {
    this.history.block((location, action) => {
      if (this.checkInterruptCase) {
        if (action === 'PUSH') {
          this.userDestination = location.pathname;
          this.userLeavingConfirmation = true;
          return false;
        }
      }
      else return true;
    });
    window.addEventListener('beforeunload', (event) => this.unloadEventListener(event));
  }
  @action.bound setLoader(message: string = '', processName?: string, progressStart?: number, progressEnd?: number) {
    const token = "token";
    if (processName || message) {
      this.loaderStack.push(token);
      this.isLoading = true;
      this.gisLoadingMessage = message;
      if (processName) this.processName = processName;
      if (progressStart !== undefined && progressEnd !== undefined) {
        this.loadingProgress = progressStart;
        this.animateProgress(progressStart, progressEnd);
      } else {
        this.loadingProgress = 0;
      }
    } else {
      this.loaderStack.pop();
      this.isLoading = this.loaderStack.length > 0;
      if (!this.isLoading) {
        this.gisLoadingMessage = '';
        this.processName = '';
        this.isLoading = false;
        this.loadingProgress = 0;
      }
    }
  }

  private async animateProgress(start: number, end: number) {
    const duration = 13000; //for smooth  increment of loader
    const steps = end - start;
    const stepDuration = duration / steps;
    for (let i = start; i <= end; i++) {
      this.loadingProgress = i;
      await new Promise(resolve => setTimeout(resolve, stepDuration));
    }
  }

  @action.bound saveProjModalToggle() {
    this.showSaveProjModal = !this.showSaveProjModal;
  }
  @action.bound loadingModalToggle(bool) {
    setTimeout(() => {
      this.isLoading = bool;
    }, 100);
  }

  @action.bound async takeCurrentScreenshot(screenshotPreview: ScreenshotPreviewVM) {
    if (this.view) {
      const screenshot = new Screenshot(
        this.view,
        efh2Store.projectsStore.currentProjectId as string,
        efh2Store.projectsStore.currentSessionId as string,
        screenshotPreview,
        this
      );
      // this.loadingResults = true;
      await screenshot.takeScreenshot({ designElementTypeId: 0 });
    }
  }

  // obserable for add comments 
  @observable noteOption: INoteOption[] = [
    {
      name: "Define AOI and DEM",
      value: "Define AOI and DEM",
    },
    {
      name: "Define Outlet",
      value: "Define Outlet",
    },
    {
      name: "Edit Watershed",
      value: "Edit Watershed",
    },
    {
      name: "Edit Land Use",
      value: "Edit Land Use",
    },
    {
      name: "Select HSG",
      value: "Select HSG",
    },
    {
      name: "Results",
      value: "Results",
    },
  ];

  @observable commentObject: ICommentObject = {

    commentAuthor: localStorage['username'],
    commentTypeId: 2,
    editStatus: 'add',
    projectComment: '',
    workflowStep: '',
    projectUuid: '',

  };
  // for add comments 

  @observable timeout: any = null;
  @observable errorMessage = '';
  @observable autoSave: boolean = false;

  @action.bound handleSelectInputChange(event) {

    const target = event.target;
    const value = target.value;
    this.projectSelectedInput = value;
  }


  @action.bound validateCommentField(value: string) {
    this.errorMessage = '';

    if (value.length > 1000) {
      this.errorMessage = this.errorMessage + 'Please limit note length to 1000 or less. ';
    }
    if (value.length === 0) {
      this.disableSaveComment = true
      this.errorMessage = this.errorMessage + 'Please Enter Input ';
    }
    if (!blockMostSpecialChars(value)) {
      this.disableSaveComment = true
      this.errorMessage = this.errorMessage + 'Only numbers and letters are allowed. ';
    }

  }

  @action.bound handleCommentInputChange(event) {

    const target = event.target;
    this.projectCommentInput = target.value;
    if (this.projectCommentInput) {
      this.disableSaveComment = false
    }
    else {
      this.disableSaveComment = true
    }
    this.validateCommentField(this.projectCommentInput);
  }

  // For Add Comments 

  @action.bound async addComment() {
    this.disableSaveComment = true;
    this.commentObject.workflowStep = this.projectSelectedInput;
    this.commentObject.projectComment = this.projectCommentInput


    const postJSON: ProjectCommentRequest = {
      commentAuthor: this.commentObject.commentAuthor,
      commentTypeId: this.commentObject.commentTypeId,
      editStatus: this.commentObject.editStatus,
      projectComment: this.commentObject.projectComment,
      workflowStep: this.commentObject.workflowStep,
      projectUuid: efh2Store.projectsStore.currentProject.projectUuid,
    };
    try {
      await PRJAPI.ProjectCommentController.createProjectCommentByProjectUuidUsingPOST(postJSON);
      this.toggleNotes();
    } catch (error) {
      console.error(error)
    }
  }

  @action.bound async handleToggleNotes() {
    this.toggleNotes();
    try {
      await saveNote();
    } catch (err) {
      console.error(err);
    }
  }

  @action.bound openNotesModal() {
    this.projectSelectedInput = this.activityViewModel?.currentStepName;
    this.showNotesModal = true;
  }
  @action.bound toggleNotes() {
    this.showNotesModal = !this.showNotesModal;
    this.disableSaveComment = true;
  }

  @action.bound openHelpModal(helpTitle, helpContent) {
    this.showHelpModal = true;
    this.helpModalTitle = helpTitle;
    this.helpModalContent = helpContent;
  }
  @action.bound closeHelpModal() {
    this.showHelpModal = false;
    this.helpModalContent = '';
    this.helpModalTitle = '';
  }

  @action.bound async deleteProject() {
    const { projectUuid } = efh2Store.projectsStore.currentProject;

    try {
      await PRJAPI.EftProjectController.softDeleteProjectUsingDELETE(projectUuid);
      // unload project by resetting the project store
      efh2Store.projectsStore.reset();
      efh2Store.aoiContainsWatershed = true;
      efh2Store.hasValidWatershedPolygon = true;
      this.history.push('/projects');
    } catch (error) {
      console.warn('deleteProject: error = ', error);
    }
  }

  @observable formValidation = {
    formErrors: {
      projectTitle: '',
    },
    projectTitleValid: false,
    formValid: false,
  };

  @action.bound errorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage.length === 0 ? '' : ' usa-input--error';
  }

  @action.bound setMap(data: any) {
    this.map = data;
  }
  @action.bound setView(data: any) {
    this.view = data;

    //dispose previous watershed activity model, probably not necessary, don't expect this value to be set before the mapView
    if (this.activityViewModel) {
      const t = this.activityViewModel;
      this.activityViewModel = undefined;
      t.dispose();
    }

    //not ideal location for this constructor, MapView is constructed at non-deteministic time
    // this.activityViewModel = new DelineateWatershedInputStateVM(
    //   this.watershedApi,
    //   this.view,
    //   this.onActivityUpdateCallback,
    //   undefined,
    //   undefined,
    //   this.beforeActivityUpdateCallback
    // );
  }

  private soilsLayer?: FeatureLayer;
  private landuseLayer?: FeatureLayer; //to be used with landuse highlights
  private rcnFinalLayer?: FeatureLayer; //to be used with rcn highlights

  // Takes object ids from the soil/land/rcn rows that are checked.
  // Identifies the layer by what number is passed in.
  // Highlights regions by id and adds them to layerHighlights[]
  private layerHighlights: any = {};
  @action.bound onCheckboxRowChanged(data: any, layerType: number): void {
    const objectids: [any] = data;
    const mapView: MapView = this.view;
    // Set layerView by layerType. Is there a better way to do this
    // than a set of if statements?

    const allLayers = [this.soilsLayer, this.landuseLayer, this.rcnFinalLayer];
    const layerTemp = allLayers[layerType];

    if (layerTemp) {
      let layerView: GraphicsLayerView | undefined;
      try {
        layerView = mapView.allLayerViews.find((lv) => {
          return lv.layer === layerTemp;
        }) as GraphicsLayerView;
      } catch (error) {
        //non-critical error, just silence it and exit
        return;
      }
      if (layerView) {
        // Remove Unwanted
        for (const key in this.layerHighlights) {
          const objectid = parseInt(key);
          if (!objectids.includes(objectid)) {
            const handle = this.layerHighlights[objectid];
            if (handle) {
              handle.remove();
              this.layerHighlights[objectid] = null;
            }
          }
        }
        //add new highlights
        for (const objectid of objectids) {
          const handle = this.layerHighlights[objectid];
          if (!handle) {
            //only add if a objectid/handle does not already exist
            const newHandle = layerView.highlight(objectid);
            this.layerHighlights[objectid] = newHandle;
          }
        }
      }
    }
  }

  @action.bound async initialize() {
    //not sure exactly if this belongs here
    this.hasDEM = false;

    MessageCenter.fillMessageCacheByOriginalCodes(this.gisErrorMessages);
    const message = await MessageCenter.addErrorLabelFromCode("Hydro_89");
    this.drawingNotification = {
      title: "Hydrology Drawings",
      message: message
    }

    //extract the projectId from the current path/route
    const path = window.location.href;
    const routeProjectId = path.split('/').reverse()[0];
    const currentProject = efh2Store.projectsStore.currentProject;

    // 1. check for projectId in url
    // crude way of validating project id found in url
    // sample project id: d6df99c8-1148-4d1c-a452-6e353410094a
    if (routeProjectId && routeProjectId.length === 36) {
      if (currentProject && currentProject.projectUuid === routeProjectId) {
        // project is already loaded, continue using the in memory project object
        await this.loadProject(currentProject.projectUuid);
      } else {
        // if url projectId doesn't match in memory projectId, then dump in memory object and load from url projectId
        await this.loadProject(routeProjectId);
      }
    }
    // 2. check for projectId in memory - maybe?
    // Currently useless. Without project id in url -> redirect to library
    else if (currentProject && currentProject.projectUuid) {
      // if current project exists, update current route to match and then use in memory object
      this.history.replace(`/analysis/hydrology/single-watershed/${currentProject.projectUuid}`);
      await this.loadProject(currentProject.projectUuid);
    }
    // 3. No project loaded - should redirect as part of Nav"
    // Probably shouldn't be reachable
    else {
      console.warn('GISBox initialize - Could not initialize with a project');
    }
    // Set state snapshots once load routine is complete
    // This should change
    if (this.activityViewModel?.currentStepIndex !== 3) this.activityViewModel?.createSnapShotNewStep();
  }

  private async loadProject(projectId) {
    try {
      this.setLoader('Fetching data...', 'Hydrology Project', 0, 10);
      const rspns: any = await PRJAPI.EftProjectController.getProjectByIdUsingGET(projectId);
      let project = rspns.data;
      // now imediatly try and get session info to restore state etc.
      // this returns all session resources associated with a project session
      try {
        const response = await PRJAPI.EftSessionController.getSessionResourcesUsingGET(
          project.sessionList[0].sessionUuid
        );
        project.sessionList[0].sessionResources = response.data as SessionResourceObject[];
      } catch (error) {
        console.warn('loadproject error =', error);
      }

      let gpSessionId: any = undefined;

      if (project.projectUuid) {
        try {
          const response = await UserInfoController.getByUserIdUsingGET(project.projectOwnerId);
          if (response && response.data && response.data.userName) {
            project.projectOwnerEmail = response.data.userName;
          }
        }
        catch (e) {
          console.error((e as Error).message);
        }
        efh2Store.projectsStore.currentProject = project;
        project = efh2Store.projectsStore.currentProject;


        if (project.sessionList.length && project.sessionList[0].sessionUuid) {
          efh2Store.projectsStore.currentSessionId = project.sessionList[0].sessionUuid;
        }

        // sessionResourceTypeId for sessions is 1
        const findGpSessionResource = project.sessionList[0].sessionResources.find((el) => {
          return el.sessionResourceTypeId === 1;
        });
        if (project.sessionList[0] && findGpSessionResource && findGpSessionResource.sessionResourceValue) {
          gpSessionId = findGpSessionResource.sessionResourceValue;
          efh2Store.projectsStore.currentGpSessionId = gpSessionId;
          // have stagingWorksSpacePath so check for DEM here
          this.setLoader('Loading Session...', 'Hydrology Project', 10, 95);
          if (this.activityViewModel) {
            this.activityViewModel.gpSessionId = gpSessionId;
          }
          // this should remain unchainged
          const gpSessionData = await this.watershedApi.loadSession(gpSessionId);
          if (gpSessionData && gpSessionData.result_dem_layer) {
            //update the efh2Store state store
            efh2Store.gisModel.gpSessionData.output_USER_DEM = undefined; // gpSessionData.result_dem;
            efh2Store.gisModel.gpSessionData.layer_USER_DEM = gpSessionData.result_dem_layer;

            efh2Store.gisModel.gpSessionData.output_AOI_FEATURE = gpSessionData.result_aoi;
            efh2Store.gisModel.gpSessionData.output_AOI_DEM = gpSessionData.result_clipdem_layer;

            efh2Store.gisModel.gpSessionData.output_SN_CULVERTS = gpSessionData.result_culverts;
            efh2Store.gisModel.gpSessionData.output_SN_STREAMS = gpSessionData.result_streamlines;

            efh2Store.gisModel.gpSessionData.output_WS_FLOWLENGTH = gpSessionData.result_flowpath;
            efh2Store.gisModel.gpSessionData.output_WS_OUTLETS = gpSessionData.result_outlets;
            efh2Store.gisModel.gpSessionData.output_WS_WATERSHED = gpSessionData.result_watershed;

            efh2Store.gisModel.gpSessionData.output_SAL_LANDUSE = gpSessionData.result_landuse;
            efh2Store.gisModel.gpSessionData.result_soils = gpSessionData.result_soils;
            efh2Store.gisModel.gpSessionData.output_SAL_WATERSHED = undefined; // gpSessionData.result_SAL_WATERSHED;

            efh2Store.gisModel.gpSessionData.output_RCN_SUBAREAS = gpSessionData.result_rcn_subareas_layer;
            efh2Store.gisModel.gpSessionData.output_RCN_WATERSHED = gpSessionData.result_rcn_watershed;

            //dispose previous watershed activity model
            if (this.activityViewModel) {
              const t = this.activityViewModel;
              this.activityViewModel = undefined;
              t.dispose();
            }
            await updateNote();

            const salTables: any = undefined;

            //setup the new watershed activity model
            let lulcData;
            try {
              lulcData = await DelineateWatershedInputStateVM.loadSavedLandUse();
            } catch (error) {
              console.warn('Error retrieving stored Land Use/Land Cover data:', error);
              lulcData = undefined;
            }
            this.activityViewModel = new DelineateWatershedInputStateVM(
              this.watershedApi,
              this.view,
              this.drawingsGroupLayer,
              this.measuresGroupLayer,
              this.onActivityUpdateCallback,
              gpSessionData,
              gpSessionId,
              this.beforeActivityUpdateCallback,
              salTables,
              lulcData
            );

            //hook up the highlight layers
            if (this.activityViewModel.currentStepIndex >= 3) {
              // //update the GisBoxVM.landuseLayer
              // this.landuseLayer = gpSessionData.output_SAL_LANDUSE_layer;
              //update the GisBoxVM.soilsLayer
              this.soilsLayer = gpSessionData.result_soils_layer;
            }
            if (this.activityViewModel.currentStepIndex >= 4) {
              this.rcnFinalLayer = gpSessionData.result_rcn_watershed_layer;
              await this.getAndAcceptResults();
            }
            await this.activityViewModel.zoomToSubjectArea();
          }
          try {
            const results = await HydroWatershedController.getBySessionAndDesignTypeIdUsingGET1(efh2Store.projectsStore.currentSessionId);
            if (results && results.data && results.data.json) {
              const data = JSON.parse(results.data.json);
              this.activityViewModel?.setSelectedDemName(data.demName);
              this.activityViewModel?.setWatershedAcreage(parseFloat(data.watershedAcreage));
            }
            this.setLoader('Loading Drawing...', 'Hydrology Project', 95, 100);
            await this.loadDrawings();
          }
          catch (error) {
            console.error('Error getting saved design elements\n', error);
          }
          this.loadingModalToggle(false);
        } else {
          console.warn('No session or gp workspace so no DEM');
          this.loadingModalToggle(false);
        }
        if (this.activityViewModel?.currentStepIndex !== 3) this.activityViewModel?.createSnapShotNewStep();
      } else {
        console.warn('GISBox loadProject else for invisible project');
      }

      if (!(this.activityViewModel)) {
        this.activityViewModel = new DelineateWatershedInputStateVM(
          this.watershedApi,
          this.view,
          this.drawingsGroupLayer,
          this.measuresGroupLayer,
          this.onActivityUpdateCallback,
          undefined,
          gpSessionId,
          this.beforeActivityUpdateCallback
        );
        await this.activityViewModel.zoomToSubjectArea();
      }
      //To get Projection information in case of load direct url
      if (projectsLibraryStore.projectProjectionInfo === '') await getSpatialRefByProject(projectId)

    } catch (error) {
      console.warn('loadProject: error =', error);
    }
  }

  private async loadDrawings(): Promise<void> {
    this.drawingsGroupLayer.removeAll();
    this.drawings.drawingSyncSet.resetSyncSet();

    const currentSessionUuid = stores.AppStore.efh2Store.projectsStore.currentSessionId
    if (currentSessionUuid === undefined) return undefined;

    this.showLoader('Loading drawings...');

    const drawingsDesignElements = await DesignElementController.getAllDesignElementsBySessionAndTypeUsingGET(
      currentSessionUuid,
      this.drawingDesignElementName,
      true
    );

    if (drawingsDesignElements && drawingsDesignElements.data && 0 < drawingsDesignElements.data.length) {
      const drawingsJsonString = drawingsDesignElements.data[0].json!;
      const drawingsJson = JSON.parse(drawingsJsonString);
      designStore.designElementId = drawingsDesignElements.data[0].designElementId || 0;

      this.drawDesignElements(drawingsJson.drawings);
    }
  }

  // ToDo: make sure cleaning service is working
  // sends output calculations to basic data form through data store
  @action.bound async acceptResults(results, rainfallCellID, latlongInfo, lulcData) {
    // Grab project properties from efh2Store.projectStore and set them to efh2Store.basicDataForm
    //const { farmlandId } = efh2Store.projectsStore.currentProject;
    // reset rainfall and drainage here b/c we assume
    // this action wants to overwrite an excisting results in memory
    //AppStore.efh2Store.initRainfallAndDrainage();
    //efh2Store.basicDataForm.client = this.farmIDtoClient(farmlandId);
    let noRainfallData = true;
    if (rainfallCellID !== null) {
      const rainfallExistsReq = {
        rainFallIdList: [rainfallCellID]
      }
      try {
        const response = await EFH2API.HydroControllerApi.isRainFallDataExistsUsingPOST(rainfallExistsReq);
        if (response &&
          response.data &&
          response.data.rainFallList &&
          (response.data.rainFallList.length > 0) &&
          response.data.rainFallList[0].exist) {
          noRainfallData = false;
        }
      } catch {
        noRainfallData = true;
      }

      efh2Store.basicDataForm.rainfallCellID = rainfallCellID;
    }
    if (noRainfallData) {
      if (efh2Store.projectsStore.currentProject.state !== 'OR') {
        await MessageCenter.addWarningFromCode(
          ['WY', 'ID', 'WA', 'MT'].indexOf(efh2Store.projectsStore.currentProject.state) > -1 ?
            'Hydro_75' : 'Hydro_76',
          [
            {
              text: 'OK',
              callback: () => {
                MessageCenter.clearMessages();
              }
            },
          ]
        );
      }
    }

    efh2Store.basicDataForm.latlongInfo = latlongInfo;
    if (results.RCN !== null) {
      efh2Store.basicDataForm.runoffCN = results.RCN.toFixed(0);
    }
    if (results.Acres !== null) {
      efh2Store.basicDataForm.drainageArea = results.Acres.toFixed(2);
    }
    if (results.MaxFlowLengthFt !== null) {
      efh2Store.basicDataForm.watershedLen = results.MaxFlowLengthFt.toFixed(0);
    }
    if (results.Avg_Slope !== null) {
      efh2Store.basicDataForm.watershedSlope = results.Avg_Slope.toFixed(2);
    }
    efh2Store.basicDataForm.lulc_h = lulcData;

    //implement the api call to get latY and lonx---- efh2Store.projectsStore.projectClasstype
    try {
      const currentProject = efh2Store.projectsStore.currentProject
      const [latY, lonX] = latlongInfo.split(",")
      const numlatY = Number(latY)
      const numlonX = Number(lonX)
      const projectUUId = efh2Store.projectsStore.currentProject.projectUuid
      const projectionText = efh2Store.projectsStore.currentProject.projectionText
      const prams = {
        latY: numlatY,
        lonX: numlonX,
        projectClassId: currentProject.projectClassId,
        projectUuid: projectUUId,
        projectionText: projectionText,
        rainfallCellId: rainfallCellID,
      }
      if (prams) {
        try {
          await PRJAPI.EftProjectController.updateStateCountyByProjectUuidUsingPOST(prams);
          const currentProjectA = await PRJAPI.EftProjectController.getProjectByIdUsingGET(projectUUId);
          if (currentProjectA.data && currentProjectA.data.county) {
            efh2Store.projectsStore.currentProject.county = currentProjectA.data.county
          }
          if (currentProjectA.data && currentProjectA.data.state) {
            efh2Store.projectsStore.currentProject.state = currentProjectA.data.state
          }
        }
        catch (error) {
          console.error('update location failed', error)
        }
      }
    }
    catch (error) {
      console.error('Error getting saved design elements\n', error);
    }

    //advance the saved project step
    const project = stores.AppStore.efh2Store.projectsStore.currentProject;
    if (project.session) {
      project.session.stepCodeName = 'EFH2GIS-7';
      await updateProject(project);
    }
  }

  @action.bound async getAndAcceptResults() {
    if (
      !efh2Store.gisModel.gpSessionData.output_RCN_WATERSHED ||
      !efh2Store.gisModel.gpSessionData.output_RCN_WATERSHED.features
    )
      return;

    const polygon = efh2Store.gisModel.gpSessionData.output_RCN_WATERSHED.features[0].geometry as Polygon;
    const centroid = polygon.centroid;
    const rainfallCellID = await getRainfallCellID(centroid);
    const projectedCentroid = esriProjection.project(centroid, this.view.spatialReference) as Point;
    let latlongInfo = '';
    if (projectedCentroid.latitude && projectedCentroid.longitude) {
      latlongInfo = projectedCentroid.latitude + ', ' + projectedCentroid.longitude;
    }
    const lulcData = await this.getLulcdata(this.activityViewModel?.rcnSubareasArray);
    await this.acceptResults(
      this.activityViewModel?.rcnWatershedArray[0].attributes,
      rainfallCellID,
      latlongInfo,
      lulcData
    );
  }

  @action.bound async getLulcdata(subareas) {
    const lulcData: any[] = [];
    if (subareas) {
      try {
        //just a workaround to get the lulc category
        const response = await EFH2API.Efh2ControllerApi.getAllLulccnlutsUsingGET();
        const data = response.data;
        for (const el of subareas) {
          const foundLulc = data.find((landEntry) => landEntry.lcClass?.includes(el.attributes.LANDUSE.split('|')[0]));
          const lulcCategory = foundLulc?.lulcCategory;
          lulcData.push({
            lulc: lulcCategory ? lulcCategory : '',
            lulc_class: el.attributes.LANDUSE,
            lulc_condition: el.attributes.CONDITION,
            hsg_ac: el.attributes.ACRES,
            hsg: el.attributes.HYDROLGROUP,
            hsg_value: el.attributes.RCN,
          });
        }
      } catch (e) {
        console.warn('getLulcdata error = ', e);
      }
    }
    return lulcData;
  }

  @action.bound DEMAlert() {
    this.notification = {
      message: 'You have uploaded the DEM file.',
      header: 'Success!',
      type: 'success',
      hidden: false,
      timestamp: new Date(),
    };
    this.hasDEM = true;
    setTimeout(() => {
      this.notification = {
        message: '',
        header: 'Success!',
        type: 'success',
        hidden: true,
        timestamp: new Date(),
      };
    }, 3500);
  }

  updateMapPreferences() {
    const mapView = this.view;
    const prefs = mapPreferences.exportMapPreferencesFromCurrentState(mapView);
    if (prefs?.layers && stores.AppStore.userProfileStore.userPreferences) {
      const layerPrefs = {};
      for (const layer of prefs.layers) {
        if (layer.title) layerPrefs[layer.title] = layer.visible;
      }
      AppStore.userProfileStore.setPreference('analysis-hydrology-project', 'layer_visibilities', layerPrefs);
    }
  }

  @action.bound WatershedActivityNotification(error): void {
    this.clearNotification();
    let notification: INotification = { message: '', header: '', type: '', hidden: true, timestamp: undefined };
    const errMsg = error.toString();

    const findTerm = (term) => {
      if (errMsg.includes(term)) {
        return errMsg;
      }
    };

    switch (errMsg) {
      case findTerm('Please select a DEM file to upload and specify the associated elevation units for the DEM.'):
        notification = this.getNotification('Please select a DEM file to upload and specify the associated elevation units for the DEM.');
        break;
      case findTerm('the object is not in a valid state'):
        notification = this.getNotification('Please make sure to upload a DEM and select an elevation unit.');
        break;
      case findTerm('Invalid operation: Please define an AOI.'):
        notification = this.getNotification('Please define an AOI.');
        break;
      case findTerm('Invalid operation: You may only supply one AOI boundary.'):
        notification = this.getNotification('You may only supply one AOI boundary.');
        break;
      case findTerm('Invalid operation: AOI must be completely within the DEM boundary.'):
        notification = this.getNotification('AOI must be completely within the DEM boundary.');
        break;
      case findTerm('Invalid operation: Please define a valid AOI.'):
        notification = this.getNotification('AOI must be topologically correct. Either edit or redefine the current AOI boundary.');
        break;
      case findTerm('Invalid operation: Please define an outlet.'):
        notification = this.getNotification('Please define an outlet.');
        break;
      case findTerm('Invalid operation: You may only supply one Outlet.'):
        notification = this.getNotification('You may only supply one Outlet.');
        break;
      case findTerm('Invalid operation: Outlet must be completely within the AOI boundary.'):
        notification = this.getNotification('Outlet must be completely within the AOI boundary.');
        break;
      case findTerm('Invalid operation: Watershed must be completely within the AOI boundary.'):
        notification = this.getNotification('Watershed must be completely within the AOI boundary and be topologically correct. Either edit the current watershed boundary, or go back and redefine your AOI to capture the entire watershed.');
        break;
      case findTerm('Please make sure all missing values are entered for the Land Use table.'):
        notification = this.getNotification('Please make sure all missing values are entered for the Land Use table.');
        break;
      case findTerm('Please make sure all missing values are entered for the Soil table.'):
        notification = this.getNotification('Please make sure all missing values are entered for the Soil table.');
        break;
      case findTerm('the object is busy.'):
        notification = this.getNotification('The object is busy.');
        break;
      default:
        break;
    }
    this.notification = notification;
  }

  private getNotification(message: string): INotification {
    return {
      message,
      header: 'Uh oh',
      type: 'warn',
      hidden: false,
      timestamp: new Date(),
    }
  }

  @action.bound clearNotification(): void {
    this.notification = { message: '', header: '', type: '', hidden: true, timestamp: undefined };
  }
  //   To improve code coverage, commented the below function as there are no references
  /*   @action.bound AOICallback(data) {
      this.updateMapPreferences();
      // At this point we should have AOI grid numbers for rainfall call
      // for dev assume we have array here:
      // call stream service here * this is a temporary solution
      // gisfuncGetRainfallFeatures(params:any)
      if (data && data.idSet) {
        const gridPostData = data.idSet.map((el) => {
          return { id: el };
        });
        // need to save this to project I think otherwise its lost
        // can we assume we can overwrite hydrology json for this project?
        stores.AppStore.efh2Store.gisAoiGridData = gridPostData;
      }
    } */

  // for edit component
  SalVM: any = null;
  @action.bound SALEditCallback(soil: [], land: [], vm: any) {
    this.SalVM = vm;
  }

  private rcnVM: any = null;
  @action.bound RCNEditCallback(vm: any) {
    this.rcnVM = vm;
  }

  @action.bound beforeActivityUpdateCallback(
    eventData: { eventName: 'submit' | 'undo' | 'redo' },
    eventSource: DelineateWatershedInputStateVM
  ): void {
    //clear existing highlights
    // if (this.SalVM && this.activityViewModel!.currentStepIndex === 3) {
    //   this.SalVM.clearSALCheckboxes();
    // }
    if (this.rcnVM && this.activityViewModel!.currentStepIndex === 4) {
      this.rcnVM.clearRCNCheckboxes();
    }
  }

  @action.bound async onActivityUpdateCallback(
    eventData: { eventName: 'submit' | 'undo' | 'redo' },
    eventSource: DelineateWatershedInputStateVM
  ): Promise<void> {
    if (!this.activityViewModel) {
      throw new Error('Unexpected result.');
    }

    //create invisible project, if one doesn't already exist
    let project = AppStore.efh2Store.projectsStore.currentProject;

    //update the store state based on activity state
    AppStore.efh2Store.projectsStore.currentGpSessionId = this.activityViewModel.gpSessionId;

    AppStore.efh2Store.gisModel.gpSessionData.output_USER_DEM = this.activityViewModel.result_dem;

    AppStore.efh2Store.gisModel.gpSessionData.output_AOI_FEATURE = this.activityViewModel.result_aoi;
    AppStore.efh2Store.gisModel.gpSessionData.output_AOI_DEM = this.activityViewModel.result_clipdem;

    AppStore.efh2Store.gisModel.gpSessionData.output_SN_STREAMS = this.activityViewModel.result_streamlines;
    AppStore.efh2Store.gisModel.gpSessionData.output_SN_CULVERTS = this.activityViewModel.result_culverts;

    AppStore.efh2Store.gisModel.gpSessionData.output_WS_WATERSHED = this.activityViewModel.result_watershed;
    AppStore.efh2Store.gisModel.gpSessionData.output_WS_OUTLETS = this.activityViewModel.result_outlets;
    AppStore.efh2Store.gisModel.gpSessionData.output_WS_FLOWLENGTH = this.activityViewModel.result_flowpath;

    AppStore.efh2Store.gisModel.gpSessionData.output_SAL_WATERSHED = this.activityViewModel.output_RCN_WATERSHED;
    AppStore.efh2Store.gisModel.gpSessionData.result_soils = this.activityViewModel.result_soils;
    AppStore.efh2Store.gisModel.gpSessionData.output_SAL_LANDUSE = this.activityViewModel.output_SAL_LANDUSE;

    AppStore.efh2Store.gisModel.gpSessionData.output_RCN_WATERSHED = this.activityViewModel.output_RCN_WATERSHED;
    AppStore.efh2Store.gisModel.gpSessionData.output_RCN_SUBAREAS = this.activityViewModel.output_RCN_SUBAREAS;

    //hook up the highlight layers
    if (this.activityViewModel.currentStepIndex >= 3) {
      //update the GisBoxVM.landuseLayer
      this.landuseLayer = this.activityViewModel.getResultLayerById('output_SAL_LANDUSE') as FeatureLayer;
      //update the GisBoxVM.soilsLayer
      this.soilsLayer = this.activityViewModel.getResultLayerById('result_soils') as FeatureLayer;
    }
    if (this.activityViewModel.currentStepIndex >= 4) {
      this.rcnFinalLayer = this.activityViewModel.getResultLayerById('output_RCN_WATERSHED') as FeatureLayer;
    }
    // this.handleCompleteNotification(this.activityViewModel.currentStepIndex);

    // update the current step based on activity state
    const stepCodeName = this.activityViewModel.currentStepIndex + 1;
    if (eventData.eventName === 'submit') {
      project = AppStore.efh2Store.projectsStore.currentProject;
      if (
        project.sessionList[0] &&
        project.sessionList[0].sessionResources &&
        project.sessionList[0].sessionResources[0] &&
        project.sessionList[0].sessionResources[0].sessionResourceValue
      ) {
        project.sessionList[0].sessionResources[0].sessionResourceValue =
          AppStore.efh2Store.projectsStore.currentGpSessionId;
        project.sessionList[0].stepCodeId = stepCodeName;
      }
    }
  }

  @action.bound handleCompleteNotification(currentStepIndex) {
    if (currentStepIndex === 4) {
      this.notification = {
        message:
          'You have successfully completed your Watershed Analysis. Press "Next" to proceed to the Rainfall and Drainage page.',
        header: 'Success!',
        type: 'success',
        hidden: false,
        timestamp: new Date(),
      };
    }
  }

  @action.bound async handleWatershedNotification(aoiContainsWatershed) {
    if (aoiContainsWatershed !== undefined) {
      this.notification = {
        message: 'Caution: at least one watershed boundary does not lie entirely within the given area of interest.',
        header: 'Uh oh',
        type: 'warn',
        hidden: false,
        timestamp: new Date(),
      };
    }
  }

  @action.bound async createGISFilesLinkWithNotification() {
    const link = await this.createGISFilesLink();
    await MessageCenter.addNotificationFromCode('Common_24');
    return link;
  }

  @action.bound async createGISFilesLink() {
    this.isDownloading = true;
    const sessionId = stores.AppStore.efh2Store.projectsStore.currentGpSessionId;
    const projectName = stores.AppStore.efh2Store.projectsStore.currentProject.projectTitle;

    let link = '';
    if (sessionId) {
      try {
        const result = await this.watershedApi.exportSessionEfh2(sessionId, projectName);
        link = result;
      } catch (error) {
        console.error(error);
      }
    }
    this.isDownloading = false;
    return link;
  }

  // add logic to intercept LayerList Item creation and default the group layer contents as open/expanded
  private layerList: LayerList | undefined;
  @action.bound public onLayerListCreated(layerList: LayerList) {
    this.layerList = layerList;
    this.layerList.listItemCreatedFunction = this.listItemCreatedHandler;
  }
  @action.bound private listItemCreatedHandler(event: { item: ListItem }) {
    if (event.item.layer.id === 'resultsGroupLayer') {
      event.item.open = true;
    }
  }
  //user leaving 
  @observable userLeavingConfirmation: boolean = false
  @action.bound userLeavingWarningOnOk() {
    this.history.block(() => { })
    this.history.push(this.userDestination);
    this.userLeavingConfirmation = false;
  }
  @action.bound userLeavingWarningOnCancel() {
    this.userLeavingConfirmation = false;
  }
  @action.bound async onSaveStructurePendingEdits(e) {
    e.preventDefault();
    this.showLoader("Saving drawings...");

    //Logic for save Pending edit/add structure drawings
    const isSuccess = await this.saveDrawings();
    if (isSuccess) {
      // update sync data status
      this.drawings.clearSyncStatus();
    }

    this.showLoader();
  }

  private async saveDrawings() {
    // setStore.isLoading = true;
    let isSuccess = false;

    const drawingsJson: any[] = this.extractDrawingJson();

    const currentSessionUuid = stores.AppStore.efh2Store.projectsStore.currentSessionId
    if (currentSessionUuid === undefined) return undefined;

    const postJSON: any = {
      designElementId: designStore.designElementId,
      designElementName: this.drawingDesignElementName,
      designElementTypeId: this.drawingDesignElementTypeId,
      session_UUID: currentSessionUuid as string
    };

    if (drawingsJson) postJSON.drawingDesign = { drawings: drawingsJson };
    if (
      this.drawings.drawingSyncSet.getPendingEdits() ||
      drawingsJson.length > 0
    ) {
      try {
        const response: any = await StructureDrawingsController.updateDrawingsUsingPOST(postJSON);
        isSuccess = response.status === 200;
        designStore.designElementId = response.data.designElementId
        MessageCenter.clearMessages();
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      } finally {
        // setStore.isLoading = false;
      }
    }

    return isSuccess;
  }

  private showLoader(message: string = ""): void {
    if (message === "") {
      this.isLoading = false;
      this.gisLoadingMessage = "Loading...";
    } else {
      this.gisLoadingMessage = message;
      this.isLoading = true;
    }
  }

  //This function has to be there as GISBoxVM extends PendingEditManagerVM
  @action.bound async onSavePendingEdits(e) {
    e.preventDefault();
  }

  @action.bound setUncommittedEdits() {
    this.uncommittedEdits = (this.drawings ? this.drawings.pendingEditCount : 0);
    return this.uncommittedEdits;
  }

  @action.bound async openToolBar() {
    await this.inputManager.cancelCurrentOperationAsync();
    this.hideToolbar = false;
    this.activeTab = 'Measure';
    this.inputManager.mapView = this.view
  }

  @action.bound async userLeavingDrawingOnOk(e: any) {
    if (this.uncommittedEdits > 0) {
      this.openToolBar();
    }
    return false;
  }

  // Implementations of Design-Project-specific abstract methods
  onUndoLastEdit() { }
  onClearAllEdits() { }
  setUniqueDescriptions() { }
  addBreaklineEdits() { }
  toggleToolbar(designElementTypeId: number, surfaceType: any) { }
  onClickBreaklinesTool(e: any) { }
  onClickTinableTool(e: any) { }
  onClickBorderpointsTool(e: any) { }
  onClickGenerate() { }
  toggleBreaklineClosed(event: React.ChangeEvent<HTMLInputElement>) { }
  selectDescription(value: any) { }
}


interface ICommentObject {
  commentAuthor: string,
  commentTypeId: number,
  editStatus: string,
  projectComment: string,
  projectUuid: string,
  workflowStep: string,
}